import { Allergens } from 'fitbeat.models';
import i18n from './i18n';

interface IAllergenDisplay {
  value: Allergens;
  title: string;
}

export const allergens: IAllergenDisplay[] = [
  {
    title: i18n.t('settings:allergenEggs'),
    value: 'Eggs',
  },
  {
    title: i18n.t('settings:allergenDairy'),
    value: 'Dairy',
  },
  {
    title: i18n.t('settings:allergenGluten'),
    value: 'Gluten',
  },
  {
    title: i18n.t('settings:allergenNuts'),
    value: 'Nuts',
  },
];
